import classNames from 'classnames';
import styled, { keyframes } from 'styled-components';
import '../styles.scss';
import { IconProps } from '../types/icon';
import { icons } from './components';
import { PhotoUserWrapper } from './styles';

const _Icon = (props: IconProps) => {
  const { rotateLeft, rotateLeft90, className, ...rest } = props;
  const Component = icons[props.name];

  return (
    <Component
      {...rest}
      className={classNames(className, { rotateLeft, rotateLeft90 })}
    />
  );
};

const rotateLeft = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
`;

const Icon = styled(_Icon)`
  cursor: ${props => props.cursor};
  transition: transform 0.3s;

  svg {
    width: ${props => (props.width ? props.width : 14)}px;
    height: ${props =>
      props.height ? props.height : props.width ? props.width : 14}px;
  }

  svg path {
    fill: ${props => props.color};
  }

  &.rotateLeft {
    animation: ${rotateLeft} 0.3s ease-out;
  }

  &.rotateLeft90 {
    transform: rotate(-90deg);
  }
`;

export default Icon;

export const PhotoUser = (props: {
  color?: string;
  gradient?: string[];
  icon?: keyof typeof icons;
  width?: number | string;
  height?: number | string;
  iconWidth?: number | string;
  iconHeight?: number | string;
  primary?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  const {
    color = 'white',
    gradient = ['#FFAC00', '#FF3D00'],
    icon = 'starFilled',
    width = 32,
    height = 32,
    iconWidth = 14,
    iconHeight = 14,
    primary,
    className,
    onClick,
  } = props;

  let newStyle: any = {
    background: `radial-gradient( 214.37% 143.75% at 50% 50%, ${gradient[0]} 0%, ${gradient[1]} 100% )`,
    width,
    height,
    cursor: 'pointer',
  };

  if (!primary) {
    delete newStyle.background;
    newStyle.border = `1px solid ${color}`;
  }

  return (
    <PhotoUserWrapper style={newStyle} onClick={onClick} className={className}>
      <Icon name={icon} color={color} width={iconWidth} height={iconHeight} />
    </PhotoUserWrapper>
  );
};
